import { PRICE_TYPES } from 'src/common/constants';
import { formatNumber, getField, roundUpFnc } from 'src/common/helper';


export const calPriceDiscount = (price: number, discount: number | string, roundup: number) => {
    const calculatePriceDiscount = price - (price * Number(discount));

    return roundup === 1
        ? roundUpFnc(Math.round(calculatePriceDiscount), 1000)
        : Math.round(calculatePriceDiscount);
};

export const ceilPrice = (price: number) => {
    if (price >= 1000) {
        return Math.ceil(price / 1000) * 1000;
    }
    return Math.ceil(price / 100) * 100;
}

export const getMonitorType = (data: any) => {
    switch (getField(data, 'patient_select')) {
        case 1:
            return { id: 1, text: '通常' };
        case 2:
            return { id: 2, text: '部分モニター' };
        case 3:
            return { id: 3, text: '顔出しモニター' };
        default:
            return { id: 1, text: '通常' };
    }
};

export const checkHifuOrDensity = (data: any) => {
    const filterData = data.items.filter((item: any) => {
        return (
            item['surgery'] &&
            item['surgery']['surgery'] &&
            (item['surgery']['categoryid'] === 5 || item['surgery']['surgery'].includes('デンシティ'))
        );
    });

    return filterData.length > 0;
};

export const getLabelFromPatientSelect = (patientSelect: number) => {
    switch (patientSelect) {
        case PRICE_TYPES.REGULAR:
            return '通常';
        case PRICE_TYPES.PART:
            return '部分モニター';
        case PRICE_TYPES.FULL:
            return '顔出しモニター';
        default:
            return '通常';
    }
}

  
export const repairDataTable = (data: any): { dataRepair: any[]; totalAmount: number; totalAmountTax10: number; totalAmountTax8: number; quoteTotal: number } => {
    if (!data || !data.items) {
        return {dataRepair: [], totalAmount: 0, totalAmountTax10: 0, totalAmountTax8: 0, quoteTotal: 0};
    }
    let dataRepair: any[] = [];
    let totalAmount: number = 0;
    let totalAmountTax10: number = 0;
    let totalAmountTax8: number = 0;

    let actualTotalPriceOriginal = 0;
    let actualTotalPriceSalon = 0;
    let actualTotalPricePartial = 0; 
    let actualTotalPriceFullface = 0; 
    const discountNumber = Number(getField(data, 'discount', '0'));
    const monitorType = getMonitorType(data);
    const patientSelect = Number(getField(data, 'patient_select', PRICE_TYPES.REGULAR));

    data.items.forEach((item: any) => {
        const price = getField(item, 'price', 0);
        const priceMonitor = getField(item, 'price_salon', 0);
        const pricePartial = getField(item, 'price_partial', 0);
        const priceFullFace = getField(item, 'price_full_face', 0);
        const roundup = getField(item, 'roundup', 0);
        const applyDiscount = getField(item, 'apply_discount', 0);

        let treatment = item.surgery.length !== 0 ? getField(item.surgery, 'surgery') : getField(item.product, 'product');
        treatment = getField(item, 'apply_discount', 0) === 1 ? treatment + '*' : treatment;
        treatment = getField(item, 'roundup', 0) === 1 ? treatment + '^' : treatment;

        dataRepair.push({
            treatment: treatment,
            note: getField(item, 'note'),
            quantity: getField(item, 'qty'),
            price: formatNumber(price),
            priceMonitor: formatNumber(priceMonitor),
            pricePartial: formatNumber(pricePartial),
            priceFullFace: formatNumber(priceFullFace)
        });

        if(monitorType.id === 2) {
            totalAmount += applyDiscount === 1 && discountNumber !== 0 ? calPriceDiscount(pricePartial, discountNumber, getField(item, 'roundup', 0)) : pricePartial;
            if(getField(item['product'], 'ctax', 0) === 8) {
                totalAmountTax8 += applyDiscount === 1 && discountNumber !== 0 ? calPriceDiscount(pricePartial, discountNumber, getField(item, 'roundup', 0)) : pricePartial;
            } else {
                totalAmountTax10 += applyDiscount === 1 && discountNumber !== 0 ? calPriceDiscount(pricePartial, discountNumber, getField(item, 'roundup', 0)) : pricePartial;
            }
        } else if(monitorType.id === 3) {
            totalAmount += applyDiscount === 1 && discountNumber !== 0 ? calPriceDiscount(priceFullFace, discountNumber, getField(item, 'roundup', 0)) : priceFullFace;
            if(getField(item['product'], 'ctax', 0) === 8) {
                totalAmountTax8 += applyDiscount === 1 && discountNumber !== 0 ? calPriceDiscount(priceFullFace, discountNumber, getField(item, 'roundup', 0)) : priceFullFace;
            } else {
                totalAmountTax10 += applyDiscount === 1 && discountNumber !== 0 ? calPriceDiscount(priceFullFace, discountNumber, getField(item, 'roundup', 0)) : priceFullFace;
            }
        } else {
            totalAmount += applyDiscount === 1 && discountNumber !== 0 ? calPriceDiscount(price, discountNumber, getField(item, 'roundup', 0)) : price;
            if(getField(item['product'], 'ctax', 0) === 8) {
                totalAmountTax8 += applyDiscount === 1 && discountNumber !== 0 ? calPriceDiscount(price, discountNumber, getField(item, 'roundup', 0)) : price;
            } else {
                totalAmountTax10 += applyDiscount === 1 && discountNumber !== 0 ? calPriceDiscount(price, discountNumber, getField(item, 'roundup', 0)) : price;
            }
        }

        if (applyDiscount === 1) {
            actualTotalPriceOriginal += (roundup === 1) ? ceilPrice(Math.round(price * (1-discountNumber))) : Math.round(price * (1-discountNumber));
            actualTotalPriceSalon += (roundup === 1) ? ceilPrice(Math.round(priceMonitor * (1-discountNumber))) : Math.round(priceMonitor * (1-discountNumber));
            actualTotalPricePartial += (roundup === 1) ? ceilPrice(Math.round(pricePartial * (1-discountNumber))) : Math.round(pricePartial * (1-discountNumber)); 
            actualTotalPriceFullface += (roundup === 1) ? ceilPrice(Math.round(priceFullFace * (1-discountNumber))) : Math.round(priceFullFace * (1-discountNumber));
        } else {
            actualTotalPriceOriginal += price;
            actualTotalPriceSalon += priceMonitor;
            actualTotalPricePartial += pricePartial;
            actualTotalPriceFullface += priceFullFace;
        }
    });

    dataRepair.push({
        treatment: '合計',
        price: formatNumber(Number(getField(data, 'original_total', '0'))),
        priceMonitor: formatNumber(Number(getField(data, 'salon_total', '0'))),
        pricePartial: formatNumber(Number(getField(data, 'partial_total', '0'))),
        priceFullFace: formatNumber(Number(getField(data, 'full_face_total', '0'))),
    });

    const totalPriceDiscount = Number(getField(data, 'original_total', '0')) - actualTotalPriceOriginal;
    const totalPriceMonitorDiscount = Number(getField(data, 'salon_total', '0')) - actualTotalPriceSalon;
    const totalPricePartDiscount = Number(getField(data, 'partial_total', '0')) - actualTotalPricePartial;
    const totalPriceFullFaceDiscount = Number(getField(data, 'full_face_total', '0')) - actualTotalPriceFullface;

    if (totalPriceDiscount !== 0 || totalPriceMonitorDiscount !== 0 || totalPricePartDiscount !== 0 || totalPriceFullFaceDiscount !== 0) {
        const originalTotalDiscountFormat = formatNumber(totalPriceDiscount);
        const salonTotalDiscountFormat = formatNumber(totalPriceMonitorDiscount);
        const partTotalDiscountFormat = formatNumber(totalPricePartDiscount);
        const fullFaceTotalDiscountFormat = formatNumber(totalPriceFullFaceDiscount);

        dataRepair.push({
            treatment: `割引 ${discountNumber * 100}%`,
            price:
                originalTotalDiscountFormat !== '0'
                ? '-' + String(originalTotalDiscountFormat)
                : originalTotalDiscountFormat,
            priceMonitor:
                salonTotalDiscountFormat !== '0'
                ? '-' + String(salonTotalDiscountFormat)
                : salonTotalDiscountFormat,
            pricePartial:
                partTotalDiscountFormat !== '0'
                ? '-' + String(partTotalDiscountFormat)
                : partTotalDiscountFormat,
            priceFullFace:
                fullFaceTotalDiscountFormat !== '0'
                ? '-' + String(fullFaceTotalDiscountFormat)
                : fullFaceTotalDiscountFormat,
        });

        dataRepair.push({
            treatment: '割引後合計',
            price: formatNumber(actualTotalPriceOriginal),
            priceMonitor: formatNumber(actualTotalPriceSalon),
            pricePartial: formatNumber(actualTotalPricePartial),
            priceFullFace: formatNumber(actualTotalPriceFullface),
        });
    }

    const quoteTotal = (patientSelect === PRICE_TYPES.PART) ? actualTotalPricePartial : patientSelect === PRICE_TYPES.FULL ? actualTotalPriceFullface : actualTotalPriceOriginal;

    return { 
        dataRepair: dataRepair, 
        totalAmount: totalAmount, 
        totalAmountTax10: totalAmountTax10, 
        totalAmountTax8: totalAmountTax8, 
        quoteTotal: quoteTotal,
     };
};